export default __webpack_public_path__ + "static/media/easyf-login-pic.48e65668.jpg";